import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap";
import sponsorsData from "../constants/SponsorsData";
import './styles.css';

export const Sponsors = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";

  const organizers = [
    {
      id: 'uvg',
      img: "/assets/images/organizers/uvg.png",
      alt: "Universidad del Valle de Guatemala",
      name: "UVG",
      href: "https://www.uvg.edu.gt/",
      description: t("SEDE ANFITRIONA DEL CEC 2026"),
      invertLogo: true
    },
    {
      id: 'ucr',
      img: "/assets/images/organizers/ucr.png",
      alt: "Universidad de Costa Rica",
      name: "UCR",
      href: "https://www.ucr.ac.cr/",
      description: t("CO-ORGANIZADOR ACADÉMICO"),
      invertLogo: true
    },
    {
      id: 'lauvg',
      img: "/assets/images/organizers/lauvg.png",
      alt: "Laboratorio Aeroespacial UVG",
      name: "LA-UVG",
      href: "https://www.uvg.edu.gt/quetzal-2/",
      description: t("CO-ORGANIZADOR ACADÉMICO"),
      invertLogo: false
    },
    {
      id: 'unah',
      img: "/assets/images/organizers/unah.png",
      alt: "Facultad de Ciencias Espaciales UNAH",
      name: "FACES-UNAH",
      href: "https://cienciasespaciales.unah.edu.hn/",
      description: t("CO-ORGANIZADOR ACADÉMICO"),
      invertLogo: false
    },
    {
      id: 'verne',
      img: "/assets/images/organizers/verne.png",
      alt: "Verne Technologies Guatemala",
      name: "Verne Technologies",
      href: "https://www.linkedin.com/company/verne-technologies-guatemala/",
      description: t("CO-ORGANIZADOR ACADÉMICO"),
      invertLogo: true
    },
  ];

  // Check if there are any sponsors at all
  const hasSponsors = Object.values(sponsorsData).some(
    (tier) => tier.sponsors.length > 0
  );

  // Tiers in display order (highest to lowest)
  const tierOrder = ["agencies", "constellation", "galaxy", "solarSystem", "star", "planet", "institutions"];

  // Logo sizes by tier
  const tierLogoHeight = {
    agencies: "90px",
    constellation: "100px",
    galaxy: "90px",
    solarSystem: "80px",
    star: "70px",
    planet: "60px",
    institutions: "70px",
  };

  const tierColSize = {
    agencies: { md: "4", lg: "2" },
    constellation: { md: "4", lg: "3" },
    galaxy: { md: "4", lg: "3" },
    solarSystem: { md: "3", lg: "2" },
    star: { md: "3", lg: "2" },
    planet: { md: "2", lg: "2" },
    institutions: { md: "3", lg: "2" },
  };

  return (
    <section id="sponsors" className="sponsors-section py-5 bg-dark">
      <Container fluid>
        {/* Organizadores */}
        <div className="text-center mb-5">
          <h2 className="text-white mb-3">
            {t("ORGANIZADORES")}
          </h2>
        </div>

        <Row className="justify-content-center align-items-stretch g-4">
          {organizers.map((organizer) => (
            <Col
              key={organizer.id}
              xs="12" sm="6" md="4" lg="2"
              className="text-center mb-4"
              style={{ display: 'flex' }}
            >
              <div className="sponsor-card" style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <a
                  href={organizer.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sponsor-link d-block p-3"
                  style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
                  aria-label={`Visitar sitio web de ${organizer.alt}`}
                >
                  <div className="sponsor-logo-wrapper mb-3" style={{
                    height: '120px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', flexShrink: 0
                  }}>
                    <img
                      src={organizer.img}
                      alt={organizer.alt}
                      className="sponsor-logo img-fluid"
                      style={{
                        maxHeight: '100%', maxWidth: '100%',
                        filter: organizer.invertLogo ? 'brightness(0) invert(1)' : 'none',
                        opacity: organizer.invertLogo ? '0.9' : '1',
                        transition: 'all 0.3s ease'
                      }}
                      loading="lazy"
                    />
                  </div>
                  <div className="sponsor-info" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <h3 className="sponsor-name text-white h6 mb-1">{organizer.name}</h3>
                    <p className="sponsor-description text-white-50 small mb-0">{organizer.description}</p>
                  </div>
                </a>
              </div>
            </Col>
          ))}
        </Row>

        {/* Patrocinadores por nivel */}
        {hasSponsors && (
          <>
            <div className="text-center mt-5 mb-4">
              <h2 className="text-white mb-3">
                {t("PATROCINADORES")}
              </h2>
            </div>

            {tierOrder.map((tierKey) => {
              const tier = sponsorsData[tierKey];
              if (tier.sponsors.length === 0) return null;

              return (
                <div key={tierKey} className="mb-5">
                  <div className="text-center mb-3">
                    <span style={{
                      display: "inline-block",
                      padding: "0.4rem 1.5rem",
                      borderRadius: "20px",
                      background: `linear-gradient(135deg, ${tier.color}CC, ${tier.color}88)`,
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                    }}>
                      {tier.icon} {tier.label[lang]}
                    </span>
                  </div>
                  <Row className="justify-content-center align-items-center g-4">
                    {tier.sponsors.map((sponsor) => (
                      <Col
                        key={sponsor.id}
                        xs="6"
                        md={tierColSize[tierKey].md}
                        lg={tierColSize[tierKey].lg}
                        className="text-center mb-3"
                      >
                        <a
                          href={sponsor.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "120px",
                            padding: "1rem",
                            borderRadius: "12px",
                            background: "rgba(255,255,255,0.05)",
                            border: "1px solid rgba(255,255,255,0.1)",
                            transition: "all 0.3s ease",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                            e.currentTarget.style.transform = "translateY(-3px)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                            e.currentTarget.style.transform = "translateY(0)";
                          }}
                        >
                          <img
                            src={sponsor.img}
                            alt={sponsor.name}
                            style={{
                              maxHeight: tierLogoHeight[tierKey],
                              maxWidth: "100%",
                              filter: sponsor.invertLogo ? "brightness(0) invert(1)" : "none",
                              opacity: sponsor.invertLogo ? 0.9 : 1,
                            }}
                            loading="lazy"
                          />
                        </a>
                      </Col>
                    ))}
                  </Row>
                </div>
              );
            })}
          </>
        )}

        {/* CTA */}
        <div className="text-center mt-5 pt-5">
          <div className="sponsor-cta-section p-5" style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
            borderRadius: '20px',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(255,255,255,0.2)',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            <h3 className="text-white mb-3" style={{ fontSize: '2rem', fontWeight: 'bold' }}>
              {t("¿Quieres apoyar al CEC 2026?")}
            </h3>
            <p className="text-white-50 mb-4" style={{ fontSize: '1.2rem' }}>
              {t("¡Únete como patrocinador y apoya el desarrollo espacial en Centroamérica y Latinoamérica!")}
            </p>
            <button
              className="btn btn-primary btn-lg px-5 py-3"
              style={{
                fontSize: '1.1rem', fontWeight: '600',
                letterSpacing: '0.5px',
                boxShadow: '0 10px 30px rgba(13, 110, 253, 0.3)',
                border: 'none'
              }}
              onClick={() => { window.location.href = '/sponsors'; }}
            >
              🚀 {t("Conviértete en patrocinador")}
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
};